/**
 *
 * H2
 *
 */

import styled from 'styled-components';

import { BREAKPOINTS } from 'utils/constants.js';

const H2 = styled.h2`
    margin: 0;
    margin-bottom: 1rem;
    font-size; 1.75rem;
    font-weight: 300;
    
    @media screen and (max-width: ${BREAKPOINTS.tabletBreakpoint}) {
        font-size: 1.375rem;
    }
`;

export default H2;



// WEBPACK FOOTER //
// ./src/components/H2/index.js